<template>
  <div class="fullShow">
    <div class="login-layout">
      <!-- Left: login card -->
      <aside class="login-col">
        <Login ref="login" :parentPresent="parentPresent" />

        
      </aside>

      <!-- Right: plans -->
      <main class="plans-col">
        <img v-if="heroImage" :src="heroImage" alt="" class="plans-hero" />
        <PlanSelector :heroImage="heroImage" @select="onPlanSelect" />
      </main>
    </div>

    <footer class="policyConditionDiv">
      <a href="https://pteclasses.com/privacypolicy/" target="_blank" rel="noopener">Privacy Policy</a>
      <a href="https://pteclasses.com/terms-conditions/" target="_blank" rel="noopener">Terms &amp; Conditions</a>
    </footer>
  </div>
</template>

<script>
import Login from '../login'
import PlanSelector from '../PlanSelector.vue'

export default {
  props: {
    parentPresent: {
      default: 'login',
      required: false
    }
  },
  components: {
    Login,
    PlanSelector
  },
  data() {
    return {
      // Student illustration (top-right of the plans section)
      heroImage: require('../../assets/images/plans-hero.jpg')
    }
  },
  methods: {
    // TODO: replace with your real purchase flow once we know it.
    // For now: remember the chosen plan so it can be picked up after login/register,
    // send "Join For Free" to the register view, and bring the login form into focus for paid plans.
    onPlanSelect(plan) {
      this.$ls.set('selectedPlan', plan.id)
      const login = this.$refs.login
      if (!login) return

      if (plan.id === 'free') {
        login.present = 'register'
      } else {
        login.present = 'login'
      }

      this.$nextTick(() => {
        login.$el.scrollIntoView({ behavior: 'smooth', block: 'start' })
        const email = document.getElementById('login-email')
        if (email) email.focus({ preventScroll: true })
      })
    }
  }
}
</script>

<style scoped>
.fullShow {
  min-height: 100vh;
  background-color: #f4f8fe;
  background-image: url("../../assets/images/background-corner-blobs.svg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top;
  background-attachment: fixed;
  display: flex;
  flex-direction: column;
}

.login-layout {
  flex: 1;
  display: grid;
  grid-template-columns: minmax(380px, 500px) 1fr;
  gap: 20px;
  align-items: start;
  width: 100%;
  /* max-width: 1560px; */
  margin: 0 auto;
  padding: 30px 40px 16px;
}

.login-col { position: sticky; top: 24px; }
.login-col ::v-deep .loginPage { padding: 0 !important; }


</style>

<style>
.brand-tagline {
  display: flex; align-items: center; gap: 12px;
margin: 40px 0px 0px 110px;
  font-family: 'Caveat', 'Segoe Script', cursive;
  font-size: 24px; line-height: 1.05; color: #0f1d4a;
}
.brand-tagline svg { width: 50px; height: 50px; margin-right: 5px; fill: none; stroke: #0249cf; stroke-width: 1.8; }
.brand-tagline svg .fill { fill: #0249cf; stroke: none; }

.plans-col { min-width: 0; padding-top: 4px; }

@media (max-width: 1199px) {
  .login-layout { grid-template-columns: minmax(340px, 440px) 1fr; gap: 28px; padding: 28px 24px 16px; }
}
@media (max-width: 991px) {
  .login-layout { grid-template-columns: 1fr; padding: 20px 16px; }
  .login-col { position: static; max-width: 520px; width: 100%; margin: 0 auto; }
  .brand-tagline { justify-content: center; }
}
.brand-tagline {
  display: inline-block;          /* transforms don't apply to plain inline text */
  transform: rotate(-15deg);       /* negative = rises towards the top-right */
  transform-origin: left bottom;  /* pivot from the bottom-left so it stays beside the icon */
}
#footer { display: none !important; }

/* Legacy colour kept for Register / ForgotPassword / ResetPassword headings,
   but not applied to the redesigned login card title. */
.loginPage h2:not(.login-title) { color: #1e467f !important; }
.loginPage hr { border-top: 4px solid #1e467f !important; }

.policyConditionDiv {
  width: 100%;
  text-align: center;
  padding: 14px 0 18px;
}
.policyConditionDiv a {
  color: #374151;
  padding: 0 10px;
  font-size: 14px;
  text-decoration: underline;
  font-weight: 500;
}
.plans-hero {
  position: absolute; right: 0; top: 0px; width: 320px; max-height: 200px;
  object-fit: contain; object-position: bottom right; pointer-events: none;
}
</style>